import { call, put, takeEvery } from "redux-saga/effects";
import { bookiesRequest } from "../../api/bookies";
import { bookiesActions } from "../../store/bookies/actions";
import { BOOKIES_REQUEST } from "../../constants/bookies";

function* bookiesRequestSaga(): any {
  try {
    const bookies = yield call(bookiesRequest);
    yield put(bookiesActions.bookiesSuccessAction(bookies));
  } catch (e: any) {
    yield put(bookiesActions.bookiesFailureAction(e));
  }
}
function* bookiesSaga() {
  yield takeEvery(BOOKIES_REQUEST, bookiesRequestSaga);
}

export default bookiesSaga;
